module.exports = __webpack_public_path__ + "img/solidworks_camp.a80a6d7d.jpg";